<template>
  <b-modal
    :id="modalId"
    v-model="isVisible"
    @hidden="$emit('input', false)"
    ref="popup-modal"
    centered
    hide-header
    no-stacking
    size="lg"
    body-class="p-0"
    footer-class="border-0 pb-1 pr-4"
  >
    <div class="custom-modal-content">
      <!-- Botão de fechar (X) no topo direito -->
      <button type="button" class="close-button" @click="closeModal">
        <i class="fas fa-times"></i>
      </button>

      <div class="p-4">
        <!-- Título Centralizado -->
        <h2 class="popup-title">
          {{ data.title }}
        </h2>

        <!-- Conteúdo do Comunicado -->
        <div class="communication-body pt-2">
          <p v-html="data.content"></p>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="d-flex justify-content-end w-100">
        <!-- Botão Secundário (Outline) -->
        <b-button
          v-if="data.secondaryButton && data.secondaryButton.label"
          @click="handleAction(data.secondaryButton.link)"
          variant="outline-success"
          class="btn-custom-outline px-4 py-2 mr-3"
        >
          {{ data.secondaryButton.label }}
        </b-button>

        <!-- Botão Primário (Preenchido) -->
        <b-button
          v-if="data.primaryButton && data.primaryButton.label"
          @click="handleAction(data.primaryButton.link)"
          variant="success"
          class="btn-custom-filled px-4 py-2"
        >
          {{ data.primaryButton.label }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { visualizePopUp } from '../../services/communication/popupCommunique';

export default {
  name: "CommunicationPopUpModal",
  props: {
    data: { type: Object, required: true },
    value: { type: Boolean, default: false }, 
    modalId: { type: String, default: "communication-popup-modal" }
  },
  computed: {
    isVisible: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    }
  },
  methods: {
    closeModal() {
      this.isVisible = false;
    },
    async handleAction(link) {
      const isAdmin = this.$store.getters.isAdmin;

       try {        
        if (!isAdmin && this.data && this.data.id) {
          await visualizePopUp(this.data.id);
          console.log("Visualização registrada com sucesso.");
        }
      } catch (error) {        
        console.error("Erro ao registrar visualização do popup:", error);
      }
      if (link) {
        if (link.startsWith('http')) {
          window.open(link, '_blank');
        } else {
          this.$router.push(link).catch(() => {});
        }
      }
      this.closeModal();
    }
  }
};
</script>

<style lang="scss" scoped>

.custom-modal-content {
  position: relative;
  
  .close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    background: none;
    border: none;
    font-size: 1.2rem;
    color: #999;
    cursor: pointer;
    z-index: 10;
  }
}

.popup-title {
  color: var(--text-01-body, #212529);
  text-align: center;
  font-family: "Trebuchet MS", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 1.5rem;
  width: 100%;
}

.communication-body {
  /* Limita a altura do conteúdo e adiciona rolagem vertical se necessário */
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;

  /* Garante que links longos ou palavras sem espaço quebrem a linha */
  word-break: break-word;
  overflow-wrap: anywhere;

  &, ::v-deep p, ::v-deep span {
    color: var(--text-01-body, #212529);
    font-family: "Trebuchet MS", sans-serif;
    font-size: 16px;
    font-style: normal;    
    line-height: 24px;
    text-align: left;
  }

  /* Trata mídias injetadas pelo CKEditor */
  ::v-deep {
    img, table, iframe, video {
      max-width: 100% !important;
      height: auto !important;
      display: block;
      margin: 10px auto;
      object-fit: contain;
    }

    table {
      width: 100% !important;
      table-layout: fixed; /* Evita que tabelas estorem a largura */
    }

    figure {
      margin: 0;
      max-width: 100% !important;
    }
  }
}

</style>